import React, { useState, useEffect } from "react";
import './styles.css';



const RotatingBoxes = ({ letters, remainingLetters, isRotating, correctWord, enteredWord, gameStarted, gameEnded, timeBetweenReveal, selectedWordLength, onIncorrectGuess }) => {
    const [boxes, setBoxes] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [remaining, setRemaining] = useState([...remainingLetters]); // Local copy of remaining letters
    const [wordEntered, setWordEntered] = useState(false); // Track if the correct word was entered
    const fixedYPosition = 70; // Fixed Y position for all boxes

    const wordPositionsPhone = {
        4: {
            "spacing": 0.175,
            "middle": 1.75,
            "center":2.1
        },
        5: {
            "spacing": 0.175,
            "middle": 2.25,
            "center":2.1
        },
        6: {
            "spacing": 0.165,
            "middle": 2.75,
            "center":2.15
        }
    }

    const wordPositionsComputer = {
        4: {
            "spacing": 0.05,
            "middle": 1,
            "center":2
        }, 
        5: {
            "spacing":  0.05,
            "middle": 1,
            "center":2
        },
         6: {
            "spacing":  0.05,
            "middle": 1,
            "center":2
        }
    }


    useEffect(() => {
        if (enteredWord.trim() !== "") {
            console.log("Entered Word:", enteredWord);

            // Check if enteredWord matches correctWord
            if (enteredWord.toLowerCase() === correctWord.toLowerCase()) {
                console.log("Correct Word Entered!");
                setWordEntered(true); // Set wordEntered to true when correct word is entered
                // ... (your existing code for correct guess)
            } else {
                console.log("Incorrect Guess!");
                if (onIncorrectGuess) {
                    onIncorrectGuess(); // Call the callback to notify the parent about the incorrect guess
                }
            }
        }
    }, [enteredWord, correctWord, screenWidth, onIncorrectGuess]);


    useEffect(() => {

        const middleIndex = wordPositionsPhone[letters.length]['middle']
        const boxSpacing = screenWidth < 768 ? screenWidth * wordPositionsPhone[letters.length]['spacing'] : screenWidth * wordPositionsComputer[letters.length]['spacing'] 
        const centerX = screenWidth < 768 ? screenWidth / wordPositionsPhone[letters.length]['center'] : screenWidth / wordPositionsComputer[letters.length]['center']

        let initialBoxes = [];

        // Conditional initialization based on whether the game has ended
        if (!gameEnded) {
            initialBoxes = letters.map((letter, index) => ({
                letter,
                positionX: screenWidth + index * 100, // Start positions spaced out
                targetX: centerX + (index - middleIndex) * boxSpacing, // Ensure middle letter is at screen center
                positionY: 0,
                velocityY: -15,
                rotation: 0,
                atCenter: false,
                isRevealed: false, // Initial state for revealed letters
            }));
        } else {
            initialBoxes = correctWord.split("").map((letter, index) => ({
                letter: letter.toUpperCase(), // Ensure the letter is uppercase
                positionX: screenWidth + index * 100, // Start positions spaced out
                targetX: centerX + (index - middleIndex) * boxSpacing, // Ensure middle letter is at screen center
                positionY: 0,
                velocityY: -15,
                rotation: 0,
                atCenter: false,
                isRevealed: false, // Initial state for revealed letters
            }));

        }

        setBoxes(initialBoxes);

    }, [letters, screenWidth, gameEnded, correctWord]);

    useEffect(() => {
        if (!isRotating) return; // Stop if game is ended

        const intervalId = setInterval(() => {
            setBoxes((prevBoxes) =>
                prevBoxes.map((box) => {
                    if (!box.atCenter) {
                        let newPositionX = box.positionX;
                        let newRotation = box.rotation;
                        let newAtCenter = box.atCenter;

                        // Horizontal movement
                        if (box.positionX > box.targetX) {
                            newPositionX -= 10;
                            newRotation += 10; // Adjust rotation step
                        } else {
                            newAtCenter = true; // Stop moving once it reaches the target
                            newRotation = 0; // Reset rotation
                            newPositionX = box.targetX; // Ensure exact alignment
                        }

                        // Set fixed Y position once the box stops horizontally
                        let newPositionY = newAtCenter ? fixedYPosition : box.positionY;
                        let newVelocityY = box.velocityY;

                        if (!newAtCenter) {
                            // Vertical bounce logic (only applies before reaching the target)
                            newPositionY += box.velocityY;
                            if (newPositionY >= 0) {
                                newVelocityY -= 1; // Apply gravity
                            } else {
                                newVelocityY = 15; // Reverse velocity for bounce
                                newPositionY = 0; // Reset position to ground level
                            }
                        }

                        return {
                            ...box,
                            positionX: newPositionX,
                            positionY: newPositionY,
                            velocityY: newVelocityY,
                            rotation: newRotation,
                            atCenter: newAtCenter,
                        };
                    }
                    return box;
                })
            );
        }, 20);

        return () => clearInterval(intervalId);
    }, [isRotating, gameEnded]);

    useEffect(() => {
        if (!gameStarted || remaining.length === 0) return;  // Return early if game is not started

        let index = 0; // Track which box to update

        const intervalId = setInterval(() => {
            setBoxes((prevBoxes) => {
                const updatedBoxes = [...prevBoxes];
                while (index < updatedBoxes.length) {
                    if (updatedBoxes[index].letter === "?") {
                        updatedBoxes[index] = {
                            ...updatedBoxes[index],
                            letter: remaining[0],
                            isRevealed: true, // Mark this letter as revealed
                        };
                        break;
                    }
                    index++;
                }
                return updatedBoxes;
            });

            // Move to the next letter in remaining
            setRemaining((prev) => {
                const newRemaining = prev.slice(1); // Remove the first letter
                return newRemaining;
            });

            index++; // Move to the next box
            if (index >= boxes.length || remaining.length === 0) {
                clearInterval(intervalId); // Stop once all letters are revealed
            }
        }, timeBetweenReveal);

        return () => clearInterval(intervalId); // Cleanup on component unmount
    }, [remaining, boxes.length, gameStarted]); // Add gameStarted to dependency array

    useEffect(() => {
        if (gameEnded) {
            console.log('correctWord', correctWord)
            setBoxes((prevBoxes) =>
                prevBoxes.map((box) => ({
                    ...box,
                    isRevealed: true, // Mark all boxes as revealed
                    letter: box.letter.toUpperCase(), // Ensure the correct word is displayed
                }))
            );
        }
    }, [gameEnded]); // Trigger this effect when gameEnded changes

    const boxStyle = (box) => ({
        position: "absolute",
        left: `${box.positionX}px`, // Use `left` for easier centering
        bottom: `${box.positionY}px`, // Set the Y position
        width: "50px",
        height: "50px",
        backgroundColor: wordEntered || gameEnded ? "#27ae60" : (box.isRevealed ? "#ff6347" : "#000000"), // Green when word entered or game ended
        borderRadius: "25%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transform: `rotate(${box.rotation}deg) scale(${box.isRevealed ? 1.2 : 1})`, // Add scale effect when revealed
        animation: (wordEntered || gameEnded) ? "dance 1s infinite" : "", // Apply dance animation when word is entered or game ends
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.5)", // Add a shadow around the box
    });

    return (
        <div style={{
            position: "relative",
            width: "100%",
            height: "100%",
            border: "0px solid #ffffff", // Add a border around the whole container
            padding: "10px", // Optional: add padding to avoid the boxes being too close to the border
            borderRadius: "10px", // Optional: rounded corners for the rectangle
            boxSizing: "border-box", // Ensure padding is included in the element's total width/height
        }}>
            {boxes.map((box, index) => (
                <div key={index} style={boxStyle(box)}>
                    <span style={{ color: "white", fontSize: "20px" }}>{box.letter}</span>
                </div>
            ))}
        </div>
    );
};

export default RotatingBoxes;
